import axios from "axios";
import * as types from "../types";

const baseUrl = process.env.REACT_APP_BACKEND_URL;
const url = baseUrl + "operadores/";

export const getOperadores =
  ({ page, pageSize, dataBuscar, buscando }) =>
  async (dispatch) => {
    dispatch({ type: types.GET_OPERADORES });
    try {
      const response = await axios.get(url, {
        params: {
          page,
          pageSize,
          ...dataBuscar,
        },
      });
      dispatch({
        type: types.GET_OPERADORES_SUCCESS,
        payload: {
          operadores: response.data.results,
          next: response.data.next,
          dataBuscar,
          buscando,
        },
      });
    } catch (error) {
      console.log(error.response);
      dispatch({ type: types.OPERADORES_ERROR, payload: error.response });
    }
  };

export const nextPage = ({ page, pageSize, dataBuscar }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.OPERADORES_NEXT_PAGE });
      dispatch(getOperadores({ page: page + 1, pageSize, dataBuscar }));
    } catch (error) {
      console.log(error);
    }
  };
};

export const prevPage = ({ page, pageSize, dataBuscar }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.OPERADORES_PREV_PAGE });
      dispatch(getOperadores({ page: page - 1, pageSize, dataBuscar }));
    } catch (error) {
      console.log(error);
    }
  };
};

export const changePageSize = (pageSize) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.OPERADORES_CHANGE_PAGE_SIZE, payload: pageSize });
      dispatch(getOperadores({ page: 1, pageSize }));
    } catch (error) {
      console.log(error);
    }
  };
};

export const showModal = () => {
  return (dispatch) => {
    dispatch({ type: types.OPERADORES_SHOW_MODAL });
  };
};

export const hideModal = () => {
  return (dispatch) => {
    dispatch({ type: types.OPERADORES_HIDE_MODAL });
  };
};

export const createOperador = ({ data, pageSize }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.CREATE_OPERADOR });
      await axios.post(url, data);
      dispatch({ type: types.CREATE_OPERADOR_SUCCESS });
      dispatch(
        getOperadores({
          page: 1,
          pageSize,
          buscando: true,
          dataBuscar: { estatus: "activo" },
        })
      );
    } catch (error) {
      dispatch({ type: types.OPERADORES_ERROR, payload: error.response });
      console.log(error.response);
    }
  };
};

export const getOperador = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.GET_OPERADOR });
      const response = await axios.get(`${url}${id}/`);
      dispatch({ type: types.GET_OPERADOR_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: types.OPERADORES_ERROR, payload: error.response });
      console.log(error);
    }
  };
};

export const updateOperador = ({ id, data, page, pageSize, dataBuscar }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.UPDATE_OPERADOR });
      // const token = Cookies.get('csrftoken');
      await axios.put(`${url}${id}/`, data);
      dispatch({ type: types.UPDATE_OPERADOR_SUCCESS });
      dispatch(getOperadores({ page, pageSize, dataBuscar }));
    } catch (error) {
      dispatch({ type: types.OPERADORES_ERROR, payload: error.response });
      console.log(error);
    }
  };
};

export const toggleEstatus = ({ id, estatus, page, pageSize, dataBuscar }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.TOGGLE_OPERADOR_ESTATUS });
      // const token = Cookies.get('csrftoken');
      await axios.patch(`${url}${id}/`, { estatus });
      dispatch({ type: types.TOGGLE_OPERADOR_ESTATUS_SUCCESS });
      dispatch(getOperadores({ page, pageSize, dataBuscar }));
    } catch (error) {
      dispatch({ type: types.OPERADORES_ERROR, payload: error.response });
      console.log(error);
    }
  };
};

export const deleteOperador = ({ id, page, pageSize, dataBuscar }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.DELETE_OPERADOR });
      await axios.delete(`${url}${id}/`);
      dispatch({ type: types.DELETE_OPERADOR_SUCCESS });
      dispatch(getOperadores({ page, pageSize, dataBuscar }));
    } catch (error) {
      dispatch({ type: types.OPERADORES_ERROR, payload: error.response });
      console.log(error);
    }
  };
};

export const operadoresSetExportando = (exportar) => {
  return (dispatch) => {
    dispatch({ type: types.OPERADORES_SET_EXPORTANDO, payload: exportar });
  };
};

export const getOperadoresExportar =
  ({ dataBuscar }) =>
  async (dispatch) => {
    dispatch({ type: types.GET_OPERADORES_EXPORTAR });
    try {
      const response = await axios.get(url, {
        params: {
          page: 1,
          pageSize: 100000,
          ...dataBuscar,
        },
      });
      dispatch({
        type: types.GET_OPERADORES_EXPORTAR_SUCCESS,
        payload: {
          operadoresExportar: response.data.results,
        },
      });
    } catch (error) {
      console.log(error.response);
      dispatch({ type: types.OPERADORES_ERROR, payload: error.response });
    }
  };
